/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class PaymentCategory {
  baseApi = ENV.BASE_API;

  async getPaymentCategories(accessToken, status = true) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CATEGORY}?status=${status}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createPaymentCategory(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CATEGORY}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updatePaymentCategory(accessToken, idPaymentCategory, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CATEGORY}/${idPaymentCategory}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deletePaymentCategory(accessToken, idPaymentCategory) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CATEGORY}/${idPaymentCategory}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPaymentCategoriesExcludingId(accessToken, excludeId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CATEGORY}/exclude/${excludeId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPaymentConceptsByCategoryId(accessToken, paymentCategoryId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CONCEPT}/${paymentCategoryId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createPaymentConcept(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CONCEPT}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updatePaymentConcept(accessToken, idPaymentConcept, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CONCEPT}/${idPaymentConcept}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deletePaymentConcept(accessToken, idPaymentConcept) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PAYMENT_CONCEPT}/${idPaymentConcept}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
